import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  textInfo: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(4),
  },
  carouselRoot: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 1),
  },
  carousel: {
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 30),
      margin: theme.spacing(0, 3),

      '&::before': {
        content: '""',
        width: 100,
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 30,
        zIndex: 1,
        backgroundImage: 'linear-gradient(to right, #f1f1f1 , transparent)',
      },

      '&::after': {
        content: '""',
        width: 100,
        height: '100%',
        position: 'absolute',
        top: 0,
        right: 30,
        zIndex: 1,
        backgroundImage: 'linear-gradient(to right, transparent, #f1f1f1)',
      },
    },
  },
  carouselItem: {
    textAlign: 'center',
    padding: theme.spacing(0, 10),
  },
}));
